import { inject, Injectable, signal } from '@angular/core';
import { SettingsStore } from '@stores/settings.store';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private settingsStore = inject(SettingsStore);

  isTaskDrawerPinned = this.settingsStore.isTaskDrawerPinned;
  isTaskDrawerOpen = this.settingsStore.isTaskDrawerOpen;
  selectedDepartment = this.settingsStore.selectedDepartment;

  pinUnpinTaskDrawer() {
    this.settingsStore.pinUnpinTaskDrawer();
  }

  openTaskDrawer(isOpen: boolean) {
    this.settingsStore.openTaskDrawer(isOpen);
  }

  setSelectedDepartment(department: string) {
    this.settingsStore.setSelectedDepartment(department);
  }

  reset() {
    this.settingsStore.reset();
  }
}
